import { render, staticRenderFns } from "./quickPhoto.vue?vue&type=template&id=b3ae3652&scoped=true"
import script from "./quickPhoto.vue?vue&type=script&lang=js"
export * from "./quickPhoto.vue?vue&type=script&lang=js"
import style0 from "./quickPhoto.vue?vue&type=style&index=0&id=b3ae3652&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ae3652",
  null
  
)

export default component.exports